export default __webpack_public_path__ + "static/media/icon-lock.f4df7909.svg";